import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/pedagio/';

class PedagioService {
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (data ? data.token : '')
      };
    });
  }

  save(pedagio) {
    return axios.post(API_URL + 'salvarPedagio', JSON.stringify(pedagio),
      { headers: this.headers });
  }

  getPedagio(pedagioId) {
    return axios.get(API_URL + 'pedagio/' + pedagioId, { headers: this.headers });
  }

  findAllPedagioByFiltro(idCliente, filtro) {
    return axios.get(API_URL + 'allPedagios?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
  }

  findAllPedagiosByFiltro(filtro) {
    return axios.get(API_URL + 'allPedagioByFiltro?filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
  }

  ativarPedagio(pedagioId) {
    return axios.post(API_URL + 'ativarPedagio/' + pedagioId, null, { headers: this.headers });
  }

  inativarPedagio(pedagioId, dataInativacao) {
    return axios.post(API_URL + 'inativarPedagio/' + pedagioId + '/' + dataInativacao, null, { headers: this.headers });
  }
}


export default new PedagioService();